import React from "react";
import {
    FacebookIcon,
    FacebookShareButton,
    PinterestIcon,
    PinterestShareButton,
    TwitterIcon,
    TwitterShareButton,
} from "next-share";

export default function SMSharedButton({url}) {
    return (
        <>
            <FacebookShareButton url={url}>
                <FacebookIcon size={32} round/>
            </FacebookShareButton>
            <TwitterShareButton url={url}>
                <TwitterIcon size={32} round/>
            </TwitterShareButton>
            <PinterestShareButton url={url}>
                <PinterestIcon size={32} round/>
            </PinterestShareButton>
        </>
    );
}
